import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submit } from 'redux-form';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { getPacks } from '../../actions/packs';
import { createTemplate } from '../../actions/templates';
import ModalDialog from '../../components/ModalDialog';
import { PRODUCT_BASE_ID } from '../../constant';
import { defaultPackOf } from '../../packNav';
import { getProducts } from '../../reducers/products';
import { getTemplates } from '../../reducers/templates';
import TemplateForm, { ToTemplateProperties } from '../templates/TemplateForm';
import TemplatesTable from '../templates/TemplatesTable';

const PackTemplatesTab = ({ packId }) => {
  const dispatch = useDispatch();
  const products = useSelector(getProducts);
  const templates = useSelector(getTemplates) || [];
  const [adding, setAdding] = useState(false);
  const [reload, setReload] = useState(false);

  // As in the old Templates screen: the base product's size, plus the pack of the page.
  const initialValues = useMemo(() => {
    const values = { backgroundColor: '#ffffff', transparent: true, pack: defaultPackOf(packId) };
    const base = products?.results.find((product) => product.id === PRODUCT_BASE_ID);
    if (base) {
      values.dimension = { value: { totalWidth: base.attributes.width, totalHeight: base.attributes.height }, label: `${base.attributes.width}x${base.attributes.height}` };
      values.products = [{ attributes: { height: base.attributes.height, width: base.attributes.width }, label: base.name, value: base.id }];
    }
    return values;
  }, [products, packId]);

  const handleCreate = async (values) => {
    await dispatch(createTemplate(ToTemplateProperties(values)));
    setAdding(false);
    setReload(!reload);
    dispatch(getPacks());
  };

  return (
    <>
      <Button color="primary" startIcon={<AddIcon />} onClick={() => setAdding(true)} style={{ margin: '8px 0' }}>
        Ajouter
      </Button>
      <TemplatesTable packId={packId} rows={templates} isReloaded={reload} onReload={setReload} />
      <ModalDialog
        title="Nouveau modèle"
        content={adding ? <TemplateForm onSubmit={handleCreate} initialValues={initialValues} /> : null}
        isVisible={adding}
        onConfirm={() => dispatch(submit('templateForm'))}
        onClose={() => setAdding(false)}
      />
    </>
  );
};

PackTemplatesTab.propTypes = {
  packId: PropTypes.string.isRequired,
};

export default PackTemplatesTab;
